<template>
  <div>
    <template v-if="!exportShow">
      <table  border="1" cellpadding="0" cellspacing="0" style="width:100%">
        <caption id="tablePrintText">
            <div style="font-weight:600;letter-spacing:0px">{{hotelInfo.name}}</div>
            <div style="font-weight:600">营业点交班表</div>
            <div style="display: flex;justify-content:space-between;">
                <div>
                    <span style="font-weight:600" v-if="queryShiftValue != ''">班次:{{queryShiftValue == 1 ? '早班' : queryShiftValue == 2 ? '中班' :queryShiftValue == 3 ? '晚班':queryShiftValue == 4 ? '夜班':'所有' }} </span>
                    <span style="font-weight:600">营业日期:{{listQuery.startTime}} 至 {{listQuery.endTime}}</span>
                    <!-- <span style="font-weight:600" v-if="listQuery.shiftCode" >班次:{{listQuery.shiftCode == 1 ? '早班' : listQuery.shiftCode == 2 ? '中班' :listQuery.shiftCode == 3 ? '晚班':listQuery.shiftCode == 4 ? '夜班':'' }} </span> -->
                    <span style="font-weight:600" v-if="outletsListArr.length">营业点:{{ outletsListArr.toString() }} </span>
                    <span style="font-weight:600" v-if="options.length">工号:{{ options.toString() }} </span>

                </div>
                <div>
                    <span style="font-weight:600">打印人:{{employee.name}}</span>
                    <span style="font-weight:600">打印时间:{{currentTime}}</span>
                </div>
            </div>
        </caption>
        <thead v-if="exportShow">
          <tr> <th :colspan="salesTabelTitel.length">{{hotelInfo.name}}</th></tr>
          <tr><th :colspan="salesTabelTitel.length">营业点交班表</th></tr>
          <tr>
            <th :colspan="salesTabelTitel.length/2">
              <div style="font-weight:600;textAlign:left">
                <template>营业日期:{{listQuery.startTime}} 至 {{listQuery.endTime}}</template>
              </div>
            </th>
            <th style="text-align:right" :colspan="(salesTabelTitel.length+1)/2">打印人:{{employee.name}}  打印时间:{{currentTime}}</th>
          </tr>
        </thead>
  
      </table>
      <!-- 销售 -->
      <p>销售</p>
      <table  border="1" cellpadding="0" cellspacing="0" style="width:100%">
        <tbody>
          <!-- 收款 -->
          <tr>
            <th v-for="(item,index) in salesTabelTitel" :key="index">{{item.chinese_desc}}</th>
          </tr>
          <tr v-for="tr in handoverSalesTotal" :key="tr.code">
              <td align="center" v-for="(item,index) in salesTabelTitel" :key="index">{{tr[item.code]?typeof(tr[item.code]) == 'number'?tr[item.code].toFixed(2):tr[item.code]:'0.00'}}</td>
          </tr>
          <tr>
            <td align="center" v-for="(td,index) in sumsSalesTotal" :key="index">{{typeof(td) == 'number'? td.toFixed(2):td}}</td>
          </tr>
        </tbody>
      </table>
      <p>收款</p>
      <table   border="1" cellpadding="0" cellspacing="0" style="width:100%">
        <tbody>
          <!-- 收款 -->
          <tr>
            <th v-for="(item,index) in collectionTabelTitel" :key="index">{{item.productName}}</th>
          </tr>
          <tr v-for="tr in unCollectionAndHouse" :key="tr.outletsCode">
            <td align="center" v-for="(item,index) in collectionTabelTitel" :key="index">{{tr[item.productCode]?typeof(tr[item.productCode]) == 'number'?tr[item.productCode].toFixed(2):tr[item.productCode]:'0.00'}}</td>
          </tr>
          <tr>
            <td align="center" v-for="(td,index) in sumsCollection" :key="index">{{typeof(td) == 'number'? td.toFixed(2):td}}</td>
          </tr>
        </tbody>
      </table>
      <p>统计</p>
      <table  border="1" cellpadding="0" cellspacing="0" style="width:100%">
        <tbody>
          <!-- 统计 -->
          <tr>
            <th>营业点</th>
            <th>就餐人数</th>
            <th>人均消费</th>
            <th>餐单数</th>
            <th>每单均价</th>
            <th>账单数</th>
          </tr>
          <tr v-for="tr in statisticsData" :key="tr.outletsCode">
              <td align="center">{{tr.outletsName}}</td>
              <td align="center">{{tr.people_count}}</td>
              <td align="center">{{tr.avgPeoplePrice?tr.avgPeoplePrice.toFixed(2):'0.00'}}</td>
              <td align="center">{{tr.orderCount}}</td>
              <td align="center">{{tr.avgOrderPrice?tr.avgOrderPrice.toFixed(2):'0.00'}}</td>
              <td align="center">{{tr.billCount}}</td>
          </tr>
          <tr>
              <td align="center">合计</td>
              <td align="center">{{statisticsSum.people_count}}</td>
              <td align="center">{{statisticsSum.avgPeoplePrice?(statisticsSum.avgPeoplePrice/statisticsSum.people_count).toFixed(2):'0.00'}}</td>
              <td align="center">{{statisticsSum.orderCount}}</td>
              <td align="center">{{statisticsSum.avgOrderPrice?(statisticsSum.avgOrderPrice/statisticsSum.orderCount).toFixed(2):'0.00'}}</td>
              <td align="center">{{statisticsSum.billCount}}</td>
          </tr>
        </tbody>
      </table>
    </template>
    <table v-if="exportShow" id="table"  border="1" cellpadding="0" cellspacing="0" style="width:100%">
      <caption id="tablePrintText">
          <div style="font-weight:600;letter-spacing:0px">{{hotelInfo.name}}</div>
          <div style="font-weight:600">营业点交班表</div>
          <div style="display: flex;justify-content:space-between;">
              <div>
                  <span style="font-weight:600">营业日期:{{listQuery.startTime}} 至 {{listQuery.endTime}}</span>
              </div>
              <div>
                  <span style="font-weight:600">打印人:{{employee.name}}</span>
                  <span style="font-weight:600">打印时间:{{currentTime}}</span>
              </div>
          </div>
      </caption>
      <thead v-if="exportShow">
        <tr> <th :colspan="salesTabelTitel.length">{{hotelInfo.name}}</th></tr>
        <tr><th :colspan="salesTabelTitel.length">营业点交班表</th></tr>
        <tr>
          <th :colspan="salesTabelTitel.length/2">
            <div style="font-weight:600;textAlign:left">
              <template>营业日期:{{listQuery.startTime}} 至 {{listQuery.endTime}}</template>
            </div>
          </th>
          <th style="text-align:right" :colspan="(salesTabelTitel.length+1)/2">打印人:{{employee.name}}  打印时间:{{currentTime}}</th>
        </tr>
      </thead>
      <tbody>
        <!-- 销售 -->
        <tr><td :colspan="salesTabelTitel.length">销售</td></tr>
          <tr>
            <th v-for="(item,index) in salesTabelTitel" :key="index">{{item.chinese_desc}}</th>
          </tr>
        <tr v-for="tr in handoverSalesTotal" :key="tr.code">
              <td align="center" v-for="(item,index) in salesTabelTitel" :key="index">{{tr[item.code]?typeof(tr[item.code]) == 'number'?tr[item.code].toFixed(2):tr[item.code]:'0.00'}}</td>
          </tr>
        <tr>
          <td align="center" v-for="(td,index) in sumsSalesTotal" :key="index">{{typeof(td) == 'number'? td.toFixed(2):td}}</td>
        </tr>
        <!-- 收款 -->
        <tr><td :colspan="collectionTabelTitel.length">收款</td></tr>
          <tr>
            <th v-for="(item,index) in collectionTabelTitel" :key="index">{{item.productName}}</th>
          </tr>
        <tr v-for="tr in unCollectionAndHouse" :key="tr.outletsCode">
            <td align="center" v-for="(item,index) in collectionTabelTitel" :key="index">{{tr[item.productCode]?typeof(tr[item.productCode]) == 'number'?tr[item.productCode].toFixed(2):tr[item.productCode]:'0.00'}}</td>
          </tr>
        <tr>
          <td align="center" v-for="(td,index) in sumsCollection" :key="index">{{typeof(td) == 'number'? td.toFixed(2):td}}</td>
        </tr>
        <!-- 统计 -->
        <tr><td colspan="6">统计</td></tr>
          <tr>
            <th>营业点</th>
            <th>就餐人数</th>
            <th>人均消费</th>
            <th>餐单数</th>
            <th>每单均价</th>
            <th>账单数</th>
          </tr>
        <tr v-for="tr in statisticsData" :key="tr.outletsCode">
            <td align="center">{{tr.outletsName}}</td>
            <td align="center">{{tr.people_count}}</td>
            <td align="center">{{tr.avgPeoplePrice?tr.avgPeoplePrice.toFixed(2):'0.00'}}</td>
            <td align="center">{{tr.orderCount}}</td>
            <td align="center">{{tr.avgOrderPrice?tr.avgOrderPrice.toFixed(2):'0.00'}}</td>
            <td align="center">{{tr.billCount}}</td>
        </tr>
        <tr>
            <td align="center">合计</td>
            <td align="center">{{statisticsSum.people_count}}</td>
            <td align="center">{{statisticsSum.avgPeoplePrice?(statisticsSum.avgPeoplePrice/statisticsSum.people_count).toFixed(2):'0.00'}}</td>
            <td align="center">{{statisticsSum.orderCount}}</td>
            <td align="center">{{statisticsSum.avgOrderPrice?(statisticsSum.avgOrderPrice/statisticsSum.orderCount).toFixed(2):'0.00'}}</td>
            <td align="center">{{statisticsSum.billCount}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  
</template>
<script>
import DateUtils from '@/utils/DateUtils';
export default {
  props:{
    collectionTabelTitel:{
      type:Array,
      default:[]
    },
    unCollectionAndHouse:{
      type:Array,
      default:[]
    },
    handoverSalesTotal:{
      type:Array,
      default:[]
    },
    salesTabelTitel:{
      type:Array,
      default:[]
    },
    statisticsData:{
      type:Array,
      default:[]
    },
    statisticsSum:{
      type:Object
    },
    sumsCollection:{
      type:Array,
      default:[]
    },
    sumsSalesTotal:{
      type:Array,
      default:[]
    },
    outletsListArr:{
      type:Array,
      default:[]
    },
    options:{
      type:Array,
      default:[]
    },
    listQuery:{
      type:Object
    },
    exportShow:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      employee:JSON.parse(localStorage.getItem('user')),
      currentTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd hh:mm"), //当前的时间
      hotelInfo:JSON.parse(localStorage.getItem('hotel')),
      queryShiftValue: '',
    }
  },
  mounted(){
    this.$bus.$on('renderQueryShiftValue', val =>{
      this.queryShiftValue = val;
    });
  }

}
</script>